import { render, staticRenderFns } from "./SectionWhatsApp.vue?vue&type=template&id=35b5a542&scoped=true&"
import script from "./SectionWhatsApp.vue?vue&type=script&lang=js&"
export * from "./SectionWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhatsApp.vue?vue&type=style&index=0&id=35b5a542&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5a542",
  null
  
)

export default component.exports